var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-item-active"},[_c('kst-icon',{attrs:{"item-active-mode":"","value":_vm.data[_vm.field]}}),_c('kst-value',{attrs:{"field":_vm.field,"data":_vm.data,"catalog":_vm.catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }